import { FC, useState } from 'react';

import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { IconButton } from '@mui/material';

import WaveUIForm_V2 from '@/shared/components/forms/WaveUIForm_V2';
import FieldType from '@/shared/components/forms/WaveUIForm_V2/types/fieldType.enum';

type ReplyInputProps = {
  conversationID: string;
  onReply: (note: string, conversationID: string) => void;
};

const ReplyInput: FC<ReplyInputProps> = ({ conversationID, onReply }) => {
  const [replyNote, setReplyNote] = useState({
    note_reply: '',
  });

  return (
    <WaveUIForm_V2
      fields={[
        {
          field_type: FieldType.Text,
          field_props: {
            name: 'note_reply',
            label: '',
            value: replyNote.note_reply,
            placeholder: 'Reply to thread',
            size: 'small',
            onKeyDown: (e) => {
              if (e.key === 'Enter') {
                e.preventDefault();

                onReply(replyNote.note_reply, conversationID);
                setReplyNote({ note_reply: '' });
              }
            },
            endAdornment: (
              <IconButton
                size='small'
                onClick={() => {
                  onReply(replyNote.note_reply, conversationID);
                  setReplyNote({ note_reply: '' });
                }}
              >
                <KeyboardReturnIcon sx={{ width: 16, height: 16 }} />
              </IconButton>
            ),
          },
        },
      ]}
      getFieldsValues={(value) => {
        setReplyNote({ ...replyNote, ...value });
      }}
    />
  );
};

export default ReplyInput;
